import React from "react";

const SvgBoldIcon = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width || "1em"}
      height={width || "1em"}
      viewBox="0 0 65 80"
      style={style}
      fill="currentColor"
    >
      <defs />
      <defs>
        <clipPath id="a">
          <path d="M0 0h65v80H0z" />
        </clipPath>
      </defs>
      <g clip-path="url(#a)" data-name="bold">
        <g data-name="Group 19849">
          <path
            d="M61.475 45.248q-3.526-4.808-10.92-6.4a17.177 17.177 0 008.725-6.7 18.528 18.528 0 002.831-10.165q0-10.934-8.782-16.456T28.889 0H.003v80h33.046q15.428 0 23.69-5.989t8.264-17.692a18.243 18.243 0 00-3.528-11.071zM19.587 14.286h9.3q6.933 0 10.285 2.335t3.351 7.445a7.853 7.853 0 01-3.294 6.84q-3.294 2.336-9.939 2.445h-9.703zm22.822 49.093q-3.12 2.336-9.361 2.336H19.587V45.66h14.561q6.008 0 8.695 2.664t2.688 7.885q-.001 4.835-3.122 7.17z"
            data-name="Path 38525"
          />
        </g>
      </g>
    </svg>
  );
};

export default SvgBoldIcon;
